import type { Socket } from "socket.io-client";

import useAuthSockets, {
  type SocketEventListener,
} from "@/composition/shared/sockets/useAuthSocket.ts";
import { useConfigStore } from "@/stores/config.ts";
import { useLayoutStore } from "@/stores/layout.ts";

export interface DisruptionInfo {
  state: "active" | "inactive";
  messageDe: string;
  messageEn: string;
  messageEs: string;
  sections: Array<
    "all" | "desk" | "cvd" | "archiv" | "messenger" | "ai-research"
  >;
}
const useDisruptionInfoSocket = () => {
  const layoutStore = useLayoutStore();
  const configStore = useConfigStore();
  const socketUrl = configStore.remoteConfig.disruption_info_socket_url;
  const { initializeSocket, addSocketListeners } = useAuthSockets();
  let disruptionInfoSocket: Socket | null;

  const onDisruptionInfoUpdate = (rawMessage: string) => {
    const info = JSON.parse(rawMessage);
    layoutStore.updateDisruptionBanner(info);
  };

  const eventListeners: SocketEventListener[] = [
    {
      eventName: "disruption-info-update",
      callback: onDisruptionInfoUpdate,
    },
  ];

  const startUpDisruptionSocket = async () => {
    disruptionInfoSocket = await initializeSocket(socketUrl);

    addSocketListeners(eventListeners, disruptionInfoSocket);

    disruptionInfoSocket?.io.on("error", () => {
      disruptionInfoSocket?.disconnect();
    });
    return disruptionInfoSocket;
  };
  return {
    startUpDisruptionSocket,
  };
};

export default useDisruptionInfoSocket;
